import { InjectionToken } from '@angular/core';
import { CoreRuntimeConfig, DEFAULT_CORE_RUNTIME_CONFIG } from './core-config';

export const CORE_RUNTIME_CONFIG = new InjectionToken<CoreRuntimeConfig>(
  'CORE_RUNTIME_CONFIG',
  {
    providedIn: 'root',
    factory: () => DEFAULT_CORE_RUNTIME_CONFIG,
  }
);
